<script setup lang="ts"></script>

<template>
  <!-- Pending new illustration -->
  <div class="w-full text-center text-[10rem]">🎉</div>
</template>
